import {
  GetProgressBudgetQuery,
  GetProgressBudgetQueryVariables,
  ProgressBudgetSort,
  SortOrder,
} from '__generated__/graphql';
import gql from 'graphql-tag';
import useGraphQLPaging from 'hooks/graphql/useGraphQLPaging/useGraphQLPaging';
import { isEmpty } from 'lodash';
import { useCallback } from 'react';
import { NonNullArrayField } from 'types/util/NonNullArrayField';
import { Nullable } from 'types/util/Nullable';

export type TUseProgressBudgetData = NonNullArrayField<GetProgressBudgetQuery['progressBudgets']>;

export default function useGetProgressBudget() {
  const pageAll = useGraphQLPaging();

  const getProgressBudgets = useCallback(
    async (
      projectIds: string[],
      costCodeIds: string[],
      includeSubprojects: boolean,
      sort: Nullable<ProgressBudgetSort[]> = [{ createdOn: SortOrder.Desc }]
    ): Promise<TUseProgressBudgetData[]> => {
      const result = await pageAll<GetProgressBudgetQuery, GetProgressBudgetQueryVariables>(
        {
          document: GET_PROGRESS_BUDGET,
          variables: {
            filter: {
              project: {
                idWithDescendants: includeSubprojects ? { contains: projectIds } : undefined,
                id: !includeSubprojects ? { contains: projectIds } : undefined,
              },
              costCodeId: isEmpty(costCodeIds) ? { isNull: false } : { contains: costCodeIds },
              deletedOn: { isNull: true },
            },
            sort: sort ?? undefined,
          },
        },
        'progressBudgets',
        500
      );

      return result;
    },
    [pageAll]
  );

  return getProgressBudgets;
}

export const GET_PROGRESS_BUDGET = gql`
  query GetProgressBudget($filter: ProgressBudgetFilter, $first: Int, $after: String, $sort: [ProgressBudgetSort!]) {
    progressBudgets(first: $first, after: $after, filter: $filter, sort: $sort) {
      id
      cursor
      quantity
      value
      projectId
      costCodeId
    }
  }
`;
